/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _5 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>5 - Reducers</h2>
    <p className={styles.description}>
      <b>Редюсеры</b> (<code className={styles.code}>reducers</code>) - это чистые функции, которые принимают предыдущее
      состояние приложения и действие, а затем возвращают новое следующее состояние.{' '}
    </p>
    <p className={styles.description}>
      Они определяют, как изменяется состояние приложения в ответ на действия, отправленные в хранилище. Помните, что
      действия описывают только то, что произошло, а не как изменяется состояние приложения.{' '}
    </p>
    <CopyBlock
      text={`(previousState, action) => newState`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>Вещи, которые нельзя делать внутри редюсера: </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>Мутировать аргументы </li>
      <li className={styles.list__item}>Выполнять побочные эффекты, такие как API-запросы и т. п. </li>
      <li className={styles.list__item}>
        Вызывать нечистые функции, например <code className={styles.code}>Date.now()</code>{' '}
      </li>
    </ul>
    <p className={styles.description}>
      Как выполнять побочные эффекты мы рассмотрим далее, пока что просто помните - редюсер должен быть чистым. Получая
      те же аргументы, он должен вычислить следующее состояние и вернуть его. Без сюрпризов. Никаких побочных эффектов.
      Никаких мутаций. Просто рассчет.
    </p>
    <p className={styles.description}>
      Вот редьюсер, который принимает текущее состояние и действие как аргументы, а затем возвращает следующее
      состояние.{' '}
    </p>
    <CopyBlock
      text={`const initialState = [];

function notesReducer(state = initialState, action) {
  switch (action.type) {
    case 'ADD_NOTE':
      return [...state, action.payload];

    case 'DELETE_NOTE':
      return state.filter(note => note.id !== action.payload.id);

    default:
      return state;
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>Обратите внимание:</p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Мы создаем копию <code className={styles.code}>state</code>, а не мутируем его.
      </li>
      <li className={styles.list__item}>
        Мы возвращаем предыдущее состояние по умолчанию. Важно вернуть предыдущее состояние для любого неизвестного
        действия.{' '}
      </li>
    </ul>
    <a
      className={styles.link}
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.freecodecamp.org/news/why-redux-needs-reducers-to-be-pure-functions-d438c58ae468/"
    >
      Why Redux need reducers to be "pure functions"{' '}
    </a>
  </section>
))
